import { CHANGE_ENABLE_LAYER, CHANGE_DISABLE_LAYER, RESET_LAYER } from "../actions/type";

const initialState = {
  isEnableLayer: ["RanhGioiDiaChinh", "BienSoNha"],
  isDisableLayer: false,
};

const mapReducers = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_ENABLE_LAYER: {
      return {
        ...state,
        isEnableLayer: action.payload,
      };
    }

    case CHANGE_DISABLE_LAYER: {
      return {
        ...state,
        isDisableLayer: action.payload,
      };
    }

    case RESET_LAYER: {
      return {
        ...state,
        isEnableLayer: ["RanhGioiDiaChinh", "BienSoNha"],
        isDisableLayer: false,
      };
    }

    default:
      return state;
  }
};

export default mapReducers;
